<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  @if (!isLoading) {
    <div class="col-md-10 offset-md-1 pb-2 ziro-report-content">
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item>
          <p>{{ 'tkey;reports.microsoft.dial_plan_inventory.about_1' | translate }}</p>
          <p>
            <ziro-button
              [label]="'tkey;reports.microsoft.dial_plan_inventory.export_to_excel'"
              (clicked)="onExportClick()"
              [buttonStyle]="buttonStyles.LINK"
            ></ziro-button>
            {{ 'tkey;reports.microsoft.dial_plan_inventory.about_2' | translate }}
          </p>
          <div [innerHTML]="'tkey;reports.microsoft.dial_plan_inventory.about_3' | escapeHtml"></div>
          <p class="mb-0">
            <strong>{{ 'tkey;reports.microsoft.dial_plan_inventory.about_4' | translate }}</strong>
            {{ 'tkey;reports.microsoft.dial_plan_inventory.about_5' | translate }}
            <ziro-button
              [label]="'tkey;reports.microsoft.dial_plan_inventory.refresh_dial_plan_data'"
              (clicked)="onRefreshClick()"
              [buttonStyle]="buttonStyles.LINK"
            ></ziro-button>
            {{ 'tkey;reports.microsoft.dial_plan_inventory.about_6' | translate }}
          </p>
        </ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>
      <ziro-datatable
        [isCondensed]="true"
        [columns]="datatableCols"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'groupName'"
        [mainFilterPlaceholder]="'tkey;reports.microsoft.dial_plan_inventory.filter.text.placeholder' | translate"
        [maxLength]="150"
        [dataAutomation]="tableDataAutomation"
        [showCustomAlert]="shouldDisplayError"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.dn_report.available.filter.label'"
          [items]="availabilityFilterOptionsTexts"
          [matchFn]="isAvailableNumbersMatch"
          [dataAutomation]="'dn-inventory-availability-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.dn_report.pstn_connectivity_type.label'"
          [items]="pstnConnectivityTypeFilterOptions"
          [matchFn]="isPstnConnectivityTypeMatch"
          [dataAutomation]="'dn-inventory-pstn-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <div class="text-center" alert-content>
          {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_1' | translate }}
          <button class="btn btn-border btn-link strong" (click)="onRefreshClick()">
            {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_2' | translate }}
          </button>
          {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_3' | translate }}
        </div>
      </ziro-datatable>
    </div>
  }
</div>

<ziro-bottom-nav></ziro-bottom-nav>
